module.exports = __webpack_public_path__ + "img/Weapon_54.ab0a5690.png";